import type { NextPage } from "next";

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

const KlubArrowRightIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#FFF",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.032 18.9669C15.2254 18.9669 15.4189 18.893 15.5666 18.7453L21.7782 12.5337C22.0736 12.2383 22.0736 11.7598 21.7782 11.4644L15.5666 5.25279C15.2712 4.9574 14.7927 4.9574 14.4973 5.25279C14.2019 5.54819 14.2019 6.02672 14.4973 6.32212L20.1742 11.9991L14.4973 17.676C14.2019 17.9714 14.2019 18.4499 14.4973 18.7453C14.645 18.893 14.8385 18.9669 15.032 18.9669Z"
        fill={color}
      />
      <path
        d="M2.75597 12.7548H21.2436C21.661 12.7548 21.9998 12.416 21.9998 11.9986C21.9998 11.5811 21.661 11.2424 21.2436 11.2424H2.75596C2.33847 11.2424 1.99976 11.5811 1.99976 11.9986C1.99976 12.416 2.33848 12.7548 2.75597 12.7548Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubArrowRightIcon;
